// @flow
type Breakpoints = {
  mobile: string,
  tablet: string,
  ld: string,
  hd: string,
  uhd: string,
};

const breakpoints: Breakpoints = {
  mobile: '0px',
  tablet: '650px',
  // low def desktop
  ld: '1024px',
  // high def desktop
  hd: '1440px',
  // ultra high def desktop
  uhd: '1728px',
};

export default breakpoints;
